import { findIndex, clone } from 'lodash-es';
import ConduitEventsService from '../services/conduitEventsService';

export default {
  data() {
    return {
      searchTerms: [],
      searchResults: [],
      selected: [],
    };
  },

  created() {
    document.addEventListener('clearTabSelection', this.clearSelection);
  },

  beforeUnmount() {
    document.removeEventListener('clearTabSelection', this.clearSelection);
  },

  computed: {
    playing() {
      return this.production.playing;
    },

    production() {
      return this.$store.state.production.production;
    },

    allSelected() {
      return this.selected.length && this.selected.length === this.searchResults.length;
    },
  },

  methods: {
    clearSelection() {
      this.selected = [];
    },

    addTag(tag) {
      if (this.searchTerms.indexOf(tag) === -1) {
        this.searchTerms.push(tag);
        this.doSearch();
      }
    },

    removeTag(tag) {
      const index = findIndex(this.searchTerms, (o) => o === tag);
      this.searchTerms.splice(index, 1);
      this.doSearch();
    },

    toggleAll($event) {
      if (!$event.target.checked) {
        this.selected = [];
      } else {
        this.selected = clone(this.searchResults);
      }
    },

    async addSelectedToPlaylist(type) {
      const items = this.selected.map((item) => this.clone(item));
      await this.$store.dispatch('addLayouts', { items });
      await this.$store.dispatch('getTimelineItems'); // Ensure lookup tables are populated
      this.$store.dispatch('updateTimeline');
      document.dispatchEvent(new CustomEvent('scrollTimelineItem', {
        detail: { timelineId: items[0]?.timeline_id, flash: true },
      }));

      this.selected = [];

      ConduitEventsService.track(
        'producer.added.items-to-playlist',
        {
          type,
          count: items?.length || 1,
          production_id: this.production._id,
          component: 'tab-mixins.js',
          method: 'addSelectedToPlaylist',
          items,
        },
        {
          ownerId: this.production.owner,
          userId: this.$store.state.user.id,
          isStaff: this.$store.getters.isStaff,
        },
      );
    },

    async addSelectedToGroup(type, parentTimelineId) {
      const items = this.selected.map((item) => this.clone(item));

      await this.$store.dispatch('addLayouts', {
        parentId: parentTimelineId,
        items,
      });

      this.selected = [];

      await this.$store.dispatch('getTimelineItems', {
        timelineIds: items.map((item) => item.timeline_id),
      })

      this.$store.dispatch('updateTimeline');
      document.dispatchEvent(new CustomEvent('scrollTimelineItem', {
        detail: { timelineId: items[0]?.timeline_id, flash: true },
      }));

      ConduitEventsService.track(
        'producer.added.items-to-playlist',
        {
          type,
          count: items?.length || 1,
          production_id: this.production._id,
          component: 'tab-mixins.js',
          method: 'addSelectedToGroup',
          items,
        },
        {
          ownerId: this.production.owner,
          userId: this.$store.state.user.id,
          isStaff: this.$store.getters.isStaff,
        },
      );
    },

    async addToPlaylist(item, type) {
      // Ignore addToPlaylist while disconnected from socket server.
      if (!this.$store.state.clients.isSocketConnected) {
        console.warn('Ignoring addToPlaylist while disconnected from socket server');
        return;
      }

      const items = [this.clone(item)];

      await this.$store.dispatch('addLayouts', { items });
      await this.$store.dispatch('getTimelineItems');

      this.$store.dispatch('updateTimeline');
      this.$store.dispatch('trackSportradarInGameElement');
      document.dispatchEvent(new CustomEvent('scrollTimelineItem', {
        detail: { timelineId: items[0]?.timeline_id, flash: true },
      }));

      ConduitEventsService.track(
        'producer.added.items-to-playlist',
        {
          type,
          count: items?.length || 1,
          production_id: this.production._id,
          component: 'tab-mixins.js',
          method: 'addToPlaylist',
          items,
        },
        {
          ownerId: this.production.owner,
          userId: this.$store.state.user.id,
          isStaff: this.$store.getters.isStaff,
        },
      );
    },
  },
};
